import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const TaskJDModal = ({
  show,
  onClose,
  onSave,
  initialData,
  departments = [],
  users = [], 
}) => {
  const [formData, setFormData] = useState({
    id: "",
    code: "",
    mainJD: "",
    mainTaskList: "",
    mainWork: "",
    departmentId: "",
    userId: "", 
  });

  useEffect(() => {
    if (show) {
      if (initialData) {
        setFormData({
          id: initialData.id || "",
          code: initialData.code || "",
          mainJD: initialData.mainJD || "",
          mainTaskList: initialData.mainTaskList || "",
          mainWork: initialData.mainWork || "",
          departmentId: initialData.departmentId || "",
          userId: initialData.userId || "", 
        });
      } else {
        setFormData({
          id: "",
          code: "",
          mainJD: "",
          mainTaskList: "",
          mainWork: "",
          departmentId: "",
          userId: "", 
        });
      }
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (!formData.code.trim())
      return alert("Code không được để trống");

    if (!formData.mainJD.trim())
      return alert("Main JD không được để trống");

    const payload = {
      id: formData.id || 0,
      code: formData.code.trim(),
      mainJD: formData.mainJD.trim(),
      mainTaskList: formData.mainTaskList.trim(),
      mainWork: formData.mainWork.trim(),
      departmentId: formData.departmentId === "" ? null : Number(formData.departmentId),
      userId: formData.userId === "" ? null : Number(formData.userId), 
    };

    onSave(payload);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>
          <i className={`fas ${formData.id ? "fa-edit" : "fa-plus-circle"} me-2`}></i>
          {formData.id ? "Edit Task JD" : "Add New Task JD"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <div className="row">
            {/* Code */}
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Code</Form.Label>
                <Form.Control
                  type="text"
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  placeholder="Ví dụ: JD-001"
                />
              </Form.Group>
            </div>

            {/* User Assigned - Chỉ hiển thị duy nhất UserName */}
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold text-primary">Assignee (Người đảm nhiệm)</Form.Label>
                <Form.Select
                  name="userId"
                  value={formData.userId}
                  onChange={handleChange}
                  className="border-primary"
                >
                  <option value="">-- Chọn nhân viên --</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.userName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </div>

          {/* Department */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Department</Form.Label>
            <Form.Select
              name="departmentId"
              value={formData.departmentId}
              onChange={handleChange}
            >
              <option value="">-- Chọn phòng ban --</option>
              {departments.map((dep) => (
                <option key={dep.id} value={dep.id}>
                  {dep.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Main JD */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Main JD</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="mainJD"
              value={formData.mainJD}
              onChange={handleChange}
              placeholder="Mô tả công việc chính..."
            />
          </Form.Group>

          {/* Main Task List */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Main Task List</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="mainTaskList"
              value={formData.mainTaskList}
              onChange={handleChange}
              placeholder="Danh sách nhiệm vụ cụ thể..."
            />
          </Form.Group>

          {/* Main Work */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Main Work</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="mainWork"
              value={formData.mainWork}
              onChange={handleChange}
              placeholder="Kết quả đầu ra dự kiến..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" className="px-4" onClick={handleSave}>
          <i className="fas fa-save me-2"></i>
          {formData.id ? "Update Task" : "Create Task"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskJDModal;